import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = {
    key: 0,
    class: "ms-3 d-inline-block",
    style: { "min-width": "200px" }
};
const _hoisted_5 = { class: "d-flex align-items-center" };
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_8 = { class: "table-responsive" };
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_10 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_11 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = {
    colspan: "6",
    class: "text-center py-4"
};
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis ps-0" };
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_16 = { class: "text-muted small italic" };
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-end pe-0" };
const _hoisted_21 = { class: "dropdown" };
const _hoisted_22 = { class: "dropdown-menu" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { key: 2 };
const _hoisted_26 = {
    class: "modal fade",
    id: "ingredientCategoryModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_27 = { class: "modal-dialog modal-lg modal-dialog-centered" };
const _hoisted_28 = { class: "modal-content border-0" };
const _hoisted_29 = { class: "modal-header bg-light" };
const _hoisted_30 = { class: "modal-title fw-bold" };
const _hoisted_31 = { class: "modal-body p-4" };
const _hoisted_32 = { class: "row" };
const _hoisted_33 = { class: "col-md-6 mb-3" };
const _hoisted_34 = { class: "col-md-6 mb-3" };
const _hoisted_35 = { class: "form-check form-switch mt-2" };
const _hoisted_36 = { class: "form-check-label" };
const _hoisted_37 = { class: "col-md-12 mb-3" };
const _hoisted_38 = { class: "form-label fw-semibold" };
const _hoisted_39 = { class: "col-md-6 mb-3" };
const _hoisted_40 = { class: "col-md-6 mb-3" };
const _hoisted_41 = { class: "col-md-12 mb-3" };
const _hoisted_42 = { class: "col-md-12 mt-3 bg-light p-3 rounded" };
const _hoisted_43 = { class: "d-flex gap-2 mb-3" };
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "modal-footer border-0 bg-light" };
const _hoisted_46 = ["disabled"];
const _hoisted_47 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_48 = {
    class: "modal fade",
    id: "deleteIngredientCategoryModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_50 = { class: "modal-content" };
const _hoisted_51 = { class: "modal-body text-center p-4" };
const _hoisted_52 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args))),
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#ingredientCategoryModal"
                }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('product.manageIngredientCategories')) + " ", 1),
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                ]),
                (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_v_select, {
                            modelValue: _ctx.selectedRestaurant,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                            options: _ctx.restaurantOptions,
                            label: "name",
                            reduce: (restaurant) => restaurant.id,
                            placeholder: _ctx.$t('lists.selectRestaurant'),
                            class: "bg-white"
                        }, null, 8, ["modelValue", "options", "reduce", "placeholder"])
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                    class: "search-box position-relative me-15",
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["prevent"]))
                }, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.searchQuery) = $event)),
                        type: "text",
                        class: "form-control shadow-none text-black rounded-0 border-0",
                        placeholder: _ctx.$t('common.search'),
                        onInput: _cache[3] || (_cache[3] = ($event) => (_ctx.currentPage = 1))
                    }, null, 40, _hoisted_6), [
                        [_vModelText, _ctx.searchQuery]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("button", {
                        type: "submit",
                        class: "bg-transparent text-primary transition p-0 border-0"
                    }, [
                        _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                    ], -1))
                ], 32)
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('lists.id')), 1),
                            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('lists.name')), 1),
                            _cache[15] || (_cache[15] = _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Min Choices ", -1)),
                            _cache[16] || (_cache[16] = _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Max Additions ", -1)),
                            _cache[17] || (_cache[17] = _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Statut ", -1)),
                            _cache[18] || (_cache[18] = _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                            }, " Actions ", -1))
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                _createElementVNode("td", _hoisted_13, [
                                    _createVNode(_component_LoaderComponent)
                                ])
                            ]))
                            : (_ctx.filteredCategories.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredCategories, (cat, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: cat.id
                                    }, [
                                        _createElementVNode("td", _hoisted_14, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(cat.id)), 1),
                                        _createElementVNode("td", _hoisted_15, [
                                            _createTextVNode(_toDisplayString(cat.name) + " ", 1),
                                            _createElementVNode("div", _hoisted_16, _toDisplayString(cat.internalName), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_17, _toDisplayString(cat.minChoices || 0), 1),
                                        _createElementVNode("td", _hoisted_18, _toDisplayString(cat.maxAdditions || '∞'), 1),
                                        _createElementVNode("td", _hoisted_19, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(cat.isActive ? 'badge bg-success' : 'badge bg-danger')
                                            }, _toDisplayString(cat.isActive ? 'Actif' : 'Inactif'), 3)
                                        ]),
                                        _createElementVNode("td", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _cache[21] || (_cache[21] = _createElementVNode("button", {
                                                    class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown"
                                                }, [
                                                    _createElementVNode("i", { class: "flaticon-dots" })
                                                ], -1)),
                                                _createElementVNode("ul", _hoisted_22, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.openEditModal(cat)),
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target": "#ingredientCategoryModal"
                                                        }, [...(_cache[19] || (_cache[19] = [
                                                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                                                _createTextVNode(" Editer ", -1)
                                                            ]))], 8, _hoisted_23)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center text-danger",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.selectForDelete(cat)),
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target": "#deleteIngredientCategoryModal"
                                                        }, [...(_cache[20] || (_cache[20] = [
                                                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                                _createTextVNode(" Supprimer ", -1)
                                                            ]))], 8, _hoisted_24)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]));
                                }), 128))
                                : (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[22] || (_cache[22] = [
                                        _createElementVNode("td", {
                                            colspan: "6",
                                            class: "text-center py-4 text-muted"
                                        }, " Aucune catégorie d'ingrédients trouvée. ", -1)
                                    ]))]))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.isEditing ? 'Modifier la catégorie' : 'Nouvelle catégorie d\'ingrédients'), 1),
                        _cache[23] || (_cache[23] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Nom Interne (Admin)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formData.internalName) = $event)),
                                    class: "form-control",
                                    placeholder: "Ex: CHOIX_EXTRAS_PIZZA"
                                }, null, 512), [
                                    [_vModelText, _ctx.formData.internalName]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Statut", -1)),
                                _createElementVNode("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.isActive) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.formData.isActive]
                                    ]),
                                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.formData.isActive ? 'Activé' : 'Désactivé'), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("label", _hoisted_38, "Nom Affiché (" + _toDisplayString(_ctx.getCurrentLanguageName()) + ")", 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.currentTranslation.name) = $event)),
                                    class: "form-control",
                                    placeholder: "Ex: Choisissez vos extras"
                                }, null, 512), [
                                    [_vModelText, _ctx.currentTranslation.name]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Choix Minimum", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.formData.minChoices) = $event)),
                                    class: "form-control",
                                    min: "0"
                                }, null, 512), [
                                    [_vModelText, _ctx.formData.minChoices]
                                ]),
                                _cache[27] || (_cache[27] = _createElementVNode("small", { class: "text-muted" }, "Nombre d'ingrédients obligatoires à sélectionner.", -1))
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Maximum d'ajouts", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.formData.maxAdditions) = $event)),
                                    class: "form-control",
                                    min: "0"
                                }, null, 512), [
                                    [_vModelText, _ctx.formData.maxAdditions]
                                ]),
                                _cache[29] || (_cache[29] = _createElementVNode("small", { class: "text-muted" }, "Laisse vide ou 0 pour illimité.", -1))
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Ingrédients de cette catégorie", -1)),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.formData.ingredientIds,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.formData.ingredientIds) = $event)),
                                    options: _ctx.allIngredients,
                                    multiple: "",
                                    label: "name",
                                    reduce: ing => ing.id,
                                    placeholder: "Sélectionnez les ingrédients",
                                    class: "bg-white"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block fw-bold mb-2" }, "Traductions du Nom", -1)),
                                _createElementVNode("div", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: lang.code,
                                            type: "button",
                                            class: _normalizeClass(["btn btn-sm", _ctx.selectedLanguage === lang.code ? 'btn-primary' : 'btn-outline-secondary']),
                                            onClick: ($event) => (_ctx.selectedLanguage = lang.code)
                                        }, _toDisplayString(lang.name), 11, _hoisted_44));
                                    }), 128))
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _cache[32] || (_cache[32] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            "data-bs-dismiss": "modal"
                        }, "Annuler", -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            disabled: _ctx.isLoading,
                            onClick: _cache[11] || (_cache[11] =
                                //@ts-ignore
                                (...args) => (_ctx.saveIngredientCategory && _ctx.saveIngredientCategory(...args)))
                        }, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Mettre à jour' : 'Enregistrer'), 1)
                        ], 8, _hoisted_46)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", { class: "modal-title" }, "Confirmer la suppression"),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_51, [
                        _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-exclamation-triangle text-warning fs-1 mb-3" }, null, -1)),
                        _createElementVNode("p", null, [
                            _cache[33] || (_cache[33] = _createTextVNode("Êtes-vous sûr de vouloir supprimer la catégorie ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCategory?.name), 1),
                            _cache[34] || (_cache[34] = _createTextVNode(" ?", -1))
                        ]),
                        _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-danger small" }, "Cette action est irréversible et affectera tous les produits utilisant cette catégorie.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                        _cache[37] || (_cache[37] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            "data-bs-dismiss": "modal"
                        }, "Annuler", -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[12] || (_cache[12] =
                                //@ts-ignore
                                (...args) => (_ctx.deleteCategory && _ctx.deleteCategory(...args))),
                            "data-bs-dismiss": "modal"
                        }, "Supprimer")
                    ])
                ])
            ])
        ])
    ]));
}
